import { ScheduleSubModes } from "@common/helpers/domains/accounting/accruedScheduleMode";
import { getAccruedDefaultTermStart } from "@common/helpers/domains/accounting/accruedTermStart";
import { ScheduleSourceType } from "@common/types/domains/accounting/schedule";
import { ScheduleDraft } from "./scheduleDraft";
import { isAccruedBilledSource } from "./scheduleAccruedTerm";
import { moveScheduleDraftTermStart } from "./scheduleDraftRows";

/**
 * An accrued invoice, bill or payment schedule runs back from its billing month by
 * the term, so a start still on that default follows a term edit, the way the
 * backend recomputes it when no start is sent. A start the user moved stays.
 */
export function followAccruedDraftTermStart(options: {
    subModes: Partial<ScheduleSubModes> | undefined;
    sourceType: ScheduleSourceType;
    sourceDate: string | null;
    previous: ScheduleDraft;
    next: ScheduleDraft;
}): ScheduleDraft {
    const { subModes, sourceType, sourceDate, previous, next } = options;
    const isTermUnchanged =
        previous.termLength === next.termLength &&
        previous.termUnit === next.termUnit;
    if (
        !isAccruedBilledSource({ subModes, sourceType }) ||
        !sourceDate ||
        isTermUnchanged
    ) {
        return next;
    }
    const previousDefault = getAccruedDefaultTermStart({
        sourceDate,
        termLength: previous.termLength,
        termUnit: previous.termUnit,
    });
    if (previous.termStart !== previousDefault) {
        return next;
    }
    const nextDefault = getAccruedDefaultTermStart({
        sourceDate,
        termLength: next.termLength,
        termUnit: next.termUnit,
    });
    return nextDefault === next.termStart
        ? next
        : moveScheduleDraftTermStart({ draft: next, termStart: nextDefault });
}
